export const ECONOMY_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/#organization",
   "name": "Everest Indústria e Comércio",
   "url": "https://everest.ind.br/pt",
   "logo": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/logo-slogan.png"
   },
   "sameAs": [
    "https://www.instagram.com/everestoficial_",
    "https://www.instagram.com/everest",
    "https://www.instagram.com/everestoficial_",
    "https://www.tiktok.com/@everest_br"
   ]
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest: Qualidade em Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/#organization"
   },
   "inLanguage": "pt-BR"
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/economia#webpage",
   "url": "https://everest.ind.br/pt/economia",
   "name": "Economia com Purificadores Everest | Calculadora de Economia",
   "description": "Quanto você economiza com purificadores Everest? Acesse e descubra como reduzimos os seus gastos com água e trazemos mais qualidade no dia a dia.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/#website"
   },
   "about": {
    "@id": "https://everest.ind.br/#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/economia#breadcrumb"
   },
   "mainEntity": {
    "@id": "https://everest.ind.br/pt/economia#calculator"
   },
   "dateModified": "2026-04-16"
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/economia#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Economia",
     "item": "https://everest.ind.br/pt/economia"
    }
   ]
  },
  {
   "@type": "SoftwareApplication",
   "@id": "https://everest.ind.br/pt/economia#calculator",
   "name": "Calculadora de Economia com Purificadores Everest",
   "applicationCategory": "FinanceApplication",
   "operatingSystem": "Web",
   "description": "Ferramenta online para calcular a economia ao substituir água mineral por purificador Everest.",
   "creator": {
    "@id": "https://everest.ind.br/#organization"
   },
   "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "BRL"
   }
  }
 ]
}
